/* pp-search.js - moved out of snippets/pp-search.liquid on 2026-09-05 (pp-lcp): this used to run inline in the header group,
   before the page content had even been parsed. As a deferred asset it runs after parsing and is cached across pages. */
(function(){
  try{
    if(window.__ppSearchInit){ return; }
    window.__ppSearchInit = true;
    var doc = document;

    var overlay, panel, input, results, form;
    var isOpen = false;
    var triggerEl = null;
    var debounceTimer = null;
    var aborter = null;
    var prevBodyOverflow = '';
    var prevHtmlOverflow = '';
    var activeIndex = -1;

    var DQUOTE = String.fromCharCode(34);
    var SQUOTE = String.fromCharCode(39);
    function escHtml(s){
      return String(s == null ? '' : s)
        .split('&').join('&amp;')
        .split('<').join('&lt;')
        .split('>').join('&gt;')
        .split(DQUOTE).join('&quot;')
        .split(SQUOTE).join('&#39;');
    }
    function thumb(u){
      if(!u){ return ''; }
      try{ return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=96'; }catch(e){ return u; }
    }
    function fmtPrice(p){
      try{
        var v = p ? p.price : null;
        if(v == null || v === ''){ return ''; }
        v = String(v);
        if(/^[0-9]+$/.test(v)){ return '£' + (parseInt(v, 10) / 100).toFixed(2); }
        return v;
      }catch(e){ return ''; }
    }

    function headerBottom(){
      try{
        var h = (triggerEl && triggerEl.closest) ? triggerEl.closest('header, .shopify-section, [id^=shopify-section]') : null;
        if(h){
          var b = Math.round(h.getBoundingClientRect().bottom);
          if(b > 8 && b < 320){ return b; }
        }
      }catch(e){}
      return (window.innerWidth <= 749) ? 56 : 64;
    }

    function lockScroll(){
      try{
        prevBodyOverflow = doc.body.style.overflow;
        prevHtmlOverflow = doc.documentElement.style.overflow;
        doc.body.style.overflow = 'hidden';
        doc.documentElement.style.overflow = 'hidden';
      }catch(e){}
    }
    function unlockScroll(){
      try{
        doc.body.style.overflow = prevBodyOverflow;
        doc.documentElement.style.overflow = prevHtmlOverflow;
      }catch(e){}
    }

    function getResultOptions(){
      if(!results){ return []; }
      return Array.prototype.slice.call(results.querySelectorAll('a.pp-search__result, a.pp-search__textresult, a.pp-search__all'));
    }

    function resetActiveResult(){
      try{
        var options = getResultOptions();
        for(var i = 0; i < options.length; i++){
          options[i].classList.remove('is-active');
          options[i].setAttribute('aria-selected', 'false');
        }
        activeIndex = -1;
        if(input){ input.removeAttribute('aria-activedescendant'); }
      }catch(e){}
    }

    function moveActiveResult(direction){
      try{
        if(!results || results.hidden){ return false; }
        var options = getResultOptions();
        if(!options.length){ return false; }
        if(activeIndex < 0){ activeIndex = direction > 0 ? 0 : options.length - 1; }
        else { activeIndex = (activeIndex + direction + options.length) % options.length; }
        for(var i = 0; i < options.length; i++){
          var active = i === activeIndex;
          options[i].classList.toggle('is-active', active);
          options[i].setAttribute('aria-selected', String(active));
        }
        input.setAttribute('aria-activedescendant', options[activeIndex].id);
        try{ options[activeIndex].scrollIntoView({ block:'nearest' }); }catch(e){}
        return true;
      }catch(e){ return false; }
    }

    function clearResults(){
      try{
        resetActiveResult();
        results.innerHTML = '';
        results.hidden = true;
        if(input){ input.setAttribute('aria-expanded', 'false'); }
      }catch(e){}
    }

    function openOverlay(fromEl){
      try{
        triggerEl = fromEl || triggerEl;
        overlay.style.setProperty('--pp-search-top', headerBottom() + 'px');
        overlay.hidden = false;
        overlay.setAttribute('aria-hidden', 'false');
        lockScroll();
        void overlay.offsetWidth;
        overlay.classList.add('is-open');
        isOpen = true;
        if(window.requestAnimationFrame){
          window.requestAnimationFrame(function(){ try{ input.focus(); }catch(e){} });
        } else {
          try{ input.focus(); }catch(e){}
        }
      }catch(e){}
    }

    function closeOverlay(){
      try{
        if(!isOpen){ return; }
        isOpen = false;
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        unlockScroll();
        if(debounceTimer){ clearTimeout(debounceTimer); debounceTimer = null; }
        try{ if(aborter && aborter.abort){ aborter.abort(); } }catch(e){}
        clearResults();
        window.setTimeout(function(){ try{ if(!isOpen){ overlay.hidden = true; } }catch(e){} }, 220);
        try{ if(triggerEl && triggerEl.focus){ triggerEl.focus(); } }catch(e){}
      }catch(e){}
    }

    function renderResults(data, q){
      try{
        var res = data && data.resources && data.resources.results;
        if(!res){ clearResults(); return; }
        var products = res.products || [];
        var extra = (res.articles || []).concat(res.pages || []);
        var html = '';
        var i, p, img, pr;
        if(products.length){
          html += '<div class=pp-search__group-label>Products</div>';
          for(i = 0; i < products.length; i++){
            p = products[i];
            img = (p.featured_image && p.featured_image.url) || p.image || '';
            pr = fmtPrice(p);
            html += '<a class=pp-search__result href=' + escHtml(p.url) + '>'
                 +    '<span class=pp-search__thumb>' + (img ? '<img loading=lazy alt src=' + escHtml(thumb(img)) + '>' : '') + '</span>'
                 +    '<span class=pp-search__meta>'
                 +      '<span class=pp-search__title>' + escHtml(p.title) + '</span>'
                 +      (pr ? '<span class=pp-search__price>' + escHtml(pr) + '</span>' : '')
                 +    '</span>'
                 +  '</a>';
          }
        }
        if(extra.length){
          html += '<div class=pp-search__group-label>Guides &amp; pages</div>';
          for(i = 0; i < extra.length && i < 4; i++){
            var a = extra[i];
            html += '<a class=pp-search__textresult href=' + escHtml(a.url) + '>'
                 +    '<span class=pp-search__title>' + escHtml(a.title) + '</span>'
                 +  '</a>';
          }
        }
        if(!html){
          results.innerHTML = '<div class=pp-search__empty>No quick matches — press Enter to search.</div>';
        } else {
          html += '<a class=pp-search__all href=/search?q=' + encodeURIComponent(q) + '>See all results →</a>';
          results.innerHTML = html;
        }
        results.hidden = false;
        var options = getResultOptions();
        for(var j = 0; j < options.length; j++){
          options[j].id = 'pp-search-option-' + (j + 1);
          options[j].setAttribute('role', 'option');
          options[j].setAttribute('tabindex', '-1');
          options[j].setAttribute('aria-selected', 'false');
        }
        resetActiveResult();
        if(input){ input.setAttribute('aria-expanded', String(options.length > 0)); }
      }catch(e){}
    }

    function fetchSuggest(q){
      try{
        if(!window.fetch){ return; }
        try{ if(aborter && aborter.abort){ aborter.abort(); } }catch(e){}
        aborter = window.AbortController ? new AbortController() : null;
        var url = '/search/suggest.json?q=' + encodeURIComponent(q)
                + '&resources[type]=product,article,page'
                + '&resources[limit]=6'
                + '&resources[options][unavailable_products]=last';
        var opts = aborter ? { signal: aborter.signal } : {};
        window.fetch(url, opts).then(function(r){ return r.json(); }).then(function(data){
          try{ if(input && input.value.trim() !== q){ return; } }catch(e){}
          renderResults(data, q);
        }).catch(function(){});
      }catch(e){}
    }

    function filterByHref(list, want){
      var out = [];
      try{
        for(var i = 0; i < list.length; i++){
          var h = list[i].getAttribute ? list[i].getAttribute('href') : null;
          if(h === want){ out.push(list[i]); }
        }
      }catch(e){}
      return out;
    }
    function findTriggers(){
      try{
        var a = doc.querySelectorAll('a[aria-label=Search]');
        if(a && a.length){ return a; }
      }catch(e){}
      try{
        var b = filterByHref(doc.querySelectorAll('a.iconbtn'), '/search');
        if(b.length){ return b; }
      }catch(e){}
      try{
        return filterByHref(doc.querySelectorAll('a'), '/search');
      }catch(e){ return []; }
    }

    function init(){
      try{
        overlay = doc.getElementById('pp-search-overlay');
        if(!overlay){ return; }
        try{ if(overlay.parentNode !== doc.body){ doc.body.appendChild(overlay); } }catch(e){}
        panel   = overlay.querySelector('.pp-search__panel');
        input   = overlay.querySelector('.pp-search__input');
        results = overlay.querySelector('.pp-search__results');
        form    = overlay.querySelector('.pp-search__form');

        var triggers = findTriggers();
        if(!triggers || !triggers.length){ return; }
        triggerEl = triggers[0];
        for(var i = 0; i < triggers.length; i++){
          (function(el){
            el.addEventListener('click', function(e){
              try{ e.preventDefault(); e.stopPropagation(); }catch(err){}
              openOverlay(el);
            });
          })(triggers[i]);
        }

        if(input){
          input.addEventListener('input', function(){
            var q = input.value ? input.value.trim() : '';
            resetActiveResult();
            if(debounceTimer){ clearTimeout(debounceTimer); debounceTimer = null; }
            if(q.length < 2){ clearResults(); return; }
            debounceTimer = window.setTimeout(function(){ fetchSuggest(q); }, 200);
          });
          input.addEventListener('keydown', function(e){
            var k = e.key || e.keyCode;
            if(k === 'ArrowDown' || k === 40){
              if(moveActiveResult(1)){ e.preventDefault(); }
            } else if(k === 'ArrowUp' || k === 38){
              if(moveActiveResult(-1)){ e.preventDefault(); }
            } else if(k === 'Enter' || k === 13){
              var options = getResultOptions();
              if(activeIndex >= 0 && options[activeIndex]){
                e.preventDefault();
                options[activeIndex].click();
              }
            }
          });
        }

        if(form){
          form.addEventListener('submit', function(){
            try{ closeOverlay(); }catch(e){}
          });
        }

        overlay.addEventListener('click', function(e){
          try{
            var t = e.target;
            if(t && t.closest){
              if(t.closest('[data-pp-close]')){ e.preventDefault(); closeOverlay(); return; }
              if(!t.closest('.pp-search__panel')){ closeOverlay(); return; }
            }
          }catch(err){}
        });

        doc.addEventListener('keydown', function(e){
          try{
            if(!isOpen){ return; }
            var k = e.key || e.keyCode;
            if(k === 'Escape' || k === 'Esc' || k === 27){ e.preventDefault(); closeOverlay(); }
          }catch(err){}
        });
      }catch(e){}
    }

    if(doc.readyState === 'loading'){
      doc.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }catch(e){}
})();
